import { Base } from './base.model';

import { Type } from '../decorators/type.decorator';
import { WelcomeDocument } from "./welcome-document.model";
import { AcrProject } from "./acr-project.model";

export class EnrollmentGroup extends Base {
  public name: string;
  public available: boolean;
  public isActive: boolean;
  public acrProjectId: number;
  @Type(AcrProject) public acrProject: AcrProject;
  public enrollmentStartDate: Date;
  public enrollmentEndDate: Date;
  public docusignOneTime: number;
  public docusignTemplateId: number;
  public payPeriodCadence: number;
  public internalBufferValue: number;
  public pricePerTon: number;
  public pricePerTonMin: number;
  public marketPricePercentage: number;
  public minimumPaymentPerAcre: number;
  public minimumErtPerAcre: number;
  public initialFixedYears: number;
  public termsUrl: string;
  public faqs: string;
  public bonusAmount: number;
  public bonusLength: number;
  public bonusIsPpt: boolean;
  @Type(WelcomeDocument) public welcomeDocuments: WelcomeDocument[];
  public isCustom: boolean;
  public comments: string;
}

export interface ParcelEnrollmentGroups {
  llUuid: string;
  enrollmentGroups: EnrollmentGroup[];
}
